import { FieldRow, FieldLabel } from 'src/generic/component';
import { Input } from 'src/generic/component/form';
import { ChangeManager } from "src/generic/utils/form";
import { IFieldErrors, ErrorManager } from 'src/types/validation';
import { Draft } from 'src/types/common';
import { IContact } from 'src/types/org/common/contactSchema';
interface ContactFieldProps {
  readOnly?: boolean;
  item?: Draft<IContact>;
  original?: Draft<IContact>;
  validating?: boolean;
  errors: IFieldErrors;
  showDiff?: boolean;
  onUpdate?: (contact: Draft<IContact>) => void;
  additionalInfo?: boolean;
  customLabels?: any;
  removeFieldNote?: boolean;
}

export const ContactFields = ({ readOnly, item, original, showDiff, errors, onUpdate }: ContactFieldProps) => {
  const { getError, hasError } = ErrorManager(errors);
  const { getCurrent, isChanged, getChangeColor } = ChangeManager<IContact>(original || {}, item || {});


  const changed = (updates: Draft<IContact>) => {
    if (onUpdate) onUpdate({ ...item, ...updates });
  };

  const { name, title, phone, email } = item || {};

  return (
    <>
      <FieldRow>
        <FieldLabel variant="body1">Contact Name</FieldLabel>
        {showDiff && isChanged("name") && (
          <div>
            <i className={getChangeColor("name")}>Current: {getCurrent("name") || "(empty)"}</i>
          </div>
        )}
        <Input
          disabled={readOnly}
          value={name}
          validation={hasError('name') ? 'error' : undefined}
          validationMsg={getError('name')}
          onChange={(e) => {
            const newVal = e.target.value || undefined;

            changed({ name: newVal });
          }}
        />
      </FieldRow>
      <FieldRow>
        <FieldLabel variant="body1">Title</FieldLabel>
        {showDiff && isChanged("title") && (
          <div>
            <i className={getChangeColor("title")}>Current: {getCurrent("title") || "(empty)"}</i>
          </div>
        )}
        <Input
          disabled={readOnly}
          value={title || ''}
          validation={hasError('title') ? 'error' : undefined}
          validationMsg={getError('title')}
          onChange={(e) => {
            const newVal = e.target.value || undefined;
            changed({ title: newVal });
          }}
        />
      </FieldRow>
      <FieldRow>
        <FieldLabel variant="body1">Phone Number</FieldLabel>
        {showDiff && isChanged("phone") && (
          <div>
            <i className={getChangeColor("phone")}>Current: {getCurrent("phone") || "(empty)"}</i>
          </div>
        )}
        <Input
          disabled={readOnly}
          value={phone || ''}
          validation={hasError('phone') ? 'error' : undefined}
          validationMsg={getError('phone')}
          onChange={(e) => {
            const newVal = e.target.value || undefined;
            changed({ phone: newVal });
          }}
        />
      </FieldRow>
      <FieldRow>
        <FieldLabel variant="body1">Email </FieldLabel>
        {showDiff && isChanged("email") && (
          <div>
            <i className={getChangeColor("email")}>Current: {getCurrent("email") || "(empty)"}</i>
          </div>
        )}
        <Input
          disabled={readOnly}
          value={email}
          validation={hasError('email') ? 'error' : undefined}
          validationMsg={getError('email')}
          onChange={(e) => {
            const newVal = e.target.value || undefined;
            changed({ email: newVal });
          }}
        />
      </FieldRow>
    </>
  );
};